import PubSub from 'pubsub-js';

import { Dxf, pstOnDxfDataSet } from '../../elements/dxf';
import { DxfUnit } from '../../elements/dxf/types';
import { getUnitRelation } from '../../utilities/dxf/units-transform';

/**
 * Scales the drawings that have a unit to the target unit, so that drawings in different units
 * show in the same scale.
 */
export class ScaleHandler {
  private dxfDataSetHandle: any;

  constructor(private targetDxfUnit: DxfUnit) {}

  activate() {
    this.dxfDataSetHandle = PubSub.subscribe(pstOnDxfDataSet, (topic: string, dxf: Dxf) =>
      this.scaleDxf(dxf),
    );
  }

  deactivate() {
    PubSub.unsubscribe(this.dxfDataSetHandle);
  }

  /**
   *  Scale the dxf data to ensure it follows the scene scaling unit
   */
  private scaleDxf(dxf: Dxf) {
    // If the dxf does not have a specified unit type, skip scaling
    if (dxf.dxfUnit === DxfUnit.Unitless) {
      return;
    }

    const unitRelation = getUnitRelation(dxf.dxfUnit, this.targetDxfUnit);
    dxf.scale.setScalar(unitRelation);
    dxf.calculateLocalPosition();
  }
}
